import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Service} from '../../service';

@Component({
  templateUrl: 'login.component.html',
  styles: [` img {
    position: relative;
    height: 60px;
    width: 220px;
  }`]
})
export class LoginComponent implements OnInit {
  data: {};
  loading = false;
  disableSubmit = false;
  model = {};
  LoginError = false;

  constructor(private service: Service, private router: Router) {
  }


  ngOnInit() {
    this.checkInternetWorking();
  }

  checkInternetWorking() {
    if (navigator.onLine) {
      this.disableSubmit = false;
    } else {
      this.disableSubmit = true;
      alert('Network error: Please check your internet connection');
    }
  }

  onSubmit() {
    this.loading = true;
    this.service.initialLogin(this.model).subscribe(
      (value) => {
        this.loading = false;
        this.LoginError = false;
          this.router.navigate(['/login2']);
      },
      (error) => {
        this.loading = false;
        this.LoginError = true;
        console.log(error);
      }
    );
  }


}



// WEBPACK FOOTER //
// /home/ashutosh/submission/src/app/appcomponents/Login/login.component.ts